import React from 'react';

interface State {
  error: Error | null;
}

export class GlobalErrorBoundary extends React.Component<
  { children: React.ReactNode },
  State
> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[GlobalErrorBoundary]', error, info.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div style={{
        minHeight: '100vh',
        background: '#0f1117',
        color: '#e2e8f0',
        fontFamily: 'monospace',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        gap: '1.5rem',
      }}>
        <div style={{ fontSize: '2rem' }}>💥</div>

        <div style={{ fontSize: '1.25rem', fontWeight: 700, color: '#f87171' }}>
          Errore React non gestito
        </div>

        <div style={{
          background: '#1e2535',
          border: '1px solid #374151',
          borderRadius: '8px',
          padding: '1rem 1.25rem',
          maxWidth: '760px',
          width: '100%',
        }}>
          <div style={{ color: '#fbbf24', fontWeight: 600, marginBottom: '0.5rem' }}>
            {error.name}: {error.message}
          </div>
          {error.stack && (
            <pre style={{
              fontSize: '0.75rem',
              color: '#94a3b8',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-all',
              margin: 0,
              maxHeight: '320px',
              overflowY: 'auto',
            }}>
              {error.stack}
            </pre>
          )}
        </div>

        <div style={{ display: 'flex', gap: '0.75rem' }}>
          <button
            onClick={() => this.setState({ error: null })}
            style={{
              background: '#2a6b75',
              color: '#fff',
              border: 'none',
              borderRadius: 'var(--radius-interactive)',
              padding: '0.5rem 1.25rem',
              cursor: 'pointer',
              fontFamily: 'monospace',
            }}
          >
            Riprova
          </button>
          <button
            onClick={() => { window.location.href = '/dashboard'; }}
            style={{
              background: '#374151',
              color: '#e2e8f0',
              border: 'none',
              borderRadius: 'var(--radius-interactive)',
              padding: '0.5rem 1.25rem',
              cursor: 'pointer',
              fontFamily: 'monospace',
            }}
          >
            Torna alla Dashboard
          </button>
        </div>

        <div style={{ fontSize: '0.7rem', color: '#4b5563' }}>
          Apri DevTools → Console per lo stack trace completo
        </div>
      </div>
    );
  }
}
